import { BUGUN } from "../config.js";
import { B, cls, stu } from "../domain/context.js";
import { age, esc, fmtDate, gunFarki, money } from "../lib/fmt.js";
import { card, classChip, emptyNote, sectionTitle } from "../components/ui.js";
import { closeModal } from "../components/studentModal.js";
import { openNewStaffForm } from "./personel.js";
import { rerender } from "../lib/rerender.js";
import { Basvurular } from "../repo/entities.js";
import { state } from "../state.js";
import { ILKOKUL_ESIGI_AY, donemProjeksiyonu, tumBeklemeListeleri } from "../domain/waitlist.js";

// ---------- BAŞVURULAR ----------
export const HUNI = [
  { id: "basvuru", label: "Yeni Başvuru", color: "#4EA8DE" },
  { id: "gorusme", label: "Görüşme",      color: "#8E7CC3" },
  { id: "deneme",  label: "Deneme Günü",  color: "#F6B93B" },
  { id: "kayit",   label: "Kayıt Tamam",  color: "#0E9E8F" },
];
export const KAYIP = { id: "kaybedildi", label: "Kaybedilen", color: "#EE6C5A" };
export const KAYNAKLAR = ["Web formu", "Tavsiye", "Kardeş", "Instagram", "Telefon", "Yoldan geçen"];

export const basvuruOf = id => B().applications.find(a => a.id === id);

export function kontenjan(classId) {
  const c = cls(classId);
  if (!c) return null;
  const dolu = B().students.filter(s => s.classId === classId).length;
  return { c, dolu, kapasite: c.capacity, bos: c.capacity - dolu };
}

export function randevuMetni(iso) {
  const [tarih, saat] = iso.split("T");
  const fark = gunFarki(tarih);
  const gun = fark === 0 ? "Bugün" : fark === -1 ? "Yarın" : fmtDate(tarih);
  return { gun, saat, gecmis: fark > 0, yakin: fark >= -2 && fark <= 0 };
}

// Aşamada bekleme süresi eşiği aşınca kart uyarı rengine döner.
export const BEKLEME_ESIGI = { basvuru: 7, gorusme: 10, deneme: 10, kayit: Infinity, kaybedildi: Infinity };

export function viewBasvurular() {
  const t = B();
  // Yeni başvuru günlüğe eklenince dizinin sonuna gider; huni sütunlarında
  // en yeni aday üstte görünsün diye tarihe göre sıralanır.
  const hepsi = [...t.applications].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const aktif = hepsi.filter(a => a.stage !== "kayit" && a.stage !== "kaybedildi");
  const kayitli = hepsi.filter(a => a.stage === "kayit");
  const kayip = hepsi.filter(a => a.stage === "kaybedildi");
  const kapanan = kayitli.length + kayip.length;
  const donusum = kapanan ? Math.round((kayitli.length / kapanan) * 100) : 0;

  const randevular = hepsi
    .filter(a => a.appointmentAt && !["kayit", "kaybedildi"].includes(a.stage))
    .sort((a, b) => a.appointmentAt.localeCompare(b.appointmentAt));
  const bekleyenSure = aktif.filter(a => gunFarki(a.stageSince) > BEKLEME_ESIGI[a.stage]);

  const ozet = [
    { label: "Aktif Aday", value: aktif.length, sub: `${hepsi.length} toplam başvuru`, color: "sky" },
    { label: "Planlı Randevu", value: randevular.length, sub: randevular[0] ? `en yakını ${randevuMetni(randevular[0].appointmentAt).gun}` : "planlı randevu yok", color: "grape" },
    { label: "Dönüşüm", value: `%${donusum}`, sub: `${kayitli.length} kayıt / ${kapanan} sonuçlanan`, color: "teal" },
    { label: "Takip Gerekiyor", value: bekleyenSure.length, sub: "aşamada bekleme süresi aşıldı", color: "coral" },
  ];

  return `
  <div class="flex items-center justify-between gap-3 flex-wrap mb-4">
    <p class="text-sm text-inksoft">Kayıt hunisi — adayı bir sonraki aşamaya taşımak için karttaki okları kullanın.</p>
    <button data-newapp class="rounded-xl bg-ink text-white text-sm font-semibold px-4 py-2 hover:bg-inksoft transition">+ Yeni başvuru</button>
  </div>

  <div class="grid gap-3 sm:gap-4 grid-cols-2 xl:grid-cols-4 mb-4">
    ${ozet.map(s => card(`
      <div class="p-4">
        <div class="text-xs font-semibold text-inksoft">${s.label}</div>
        <div class="font-display font-extrabold text-3xl mt-1 text-${s.color}">${s.value}</div>
        <div class="text-[11px] text-inksoft/80 mt-0.5">${s.sub}</div>
      </div>`, "min-w-0")).join("")}
  </div>

  ${projeksiyonKarti()}
  ${beklemeKarti()}

  ${card(`
    <div class="p-5">
      ${sectionTitle("Yaklaşan Görüşme & Deneme Günleri")}
      <div class="space-y-2">
        ${randevular.map(a => {
          const r = randevuMetni(a.appointmentAt);
          const asama = HUNI.find(h => h.id === a.stage);
          return `<button data-appdetail="${a.id}" class="w-full min-w-0 flex items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition
            ${r.gecmis ? "border-coral/40 bg-coral-soft/40" : r.yakin ? "border-teal/40 bg-teal-soft/40" : "border-line hover:bg-paper/60"}">
            <span class="w-14 shrink-0 text-center">
              <span class="block text-xs font-bold" style="color:${asama.color}">${r.gun}</span>
              <span class="block font-display font-bold text-sm">${r.saat}</span>
            </span>
            <span class="min-w-0 flex-1">
              <span class="block text-sm font-semibold truncate">${esc(a.child)}</span>
              <span class="block text-[11px] text-inksoft truncate">${esc(asama.label)} · ${esc(a.parent)} · ${esc(a.phone)}</span>
            </span>
            ${r.gecmis ? `<span class="text-[10px] font-bold rounded-full bg-coral text-white px-2 py-0.5 shrink-0">Geçti</span>` : ""}
          </button>`;
        }).join("") || emptyNote("Planlanmış randevu yok.")}
      </div>
    </div>`, "mb-4")}

  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4 items-start">
    ${HUNI.map((h, i) => {
      const items = hepsi.filter(a => a.stage === h.id);
      return `<div class="min-w-0 rounded-2xl bg-paper/70 border border-line p-3">
        <div class="flex items-center gap-2 px-1 pb-2">
          <span class="w-2.5 h-2.5 rounded-full" style="background:${h.color}"></span>
          <span class="text-sm font-bold">${h.label}</span>
          <span class="text-[11px] font-bold text-inksoft ml-auto">${items.length}</span>
        </div>
        <div class="space-y-2">
          ${items.map(a => basvuruKarti(a, i)).join("") || `<div class="text-xs text-inksoft/70 text-center py-4">Aday yok</div>`}
        </div>
      </div>`;
    }).join("")}
  </div>

  ${kayip.length ? `
  <div class="mt-4">
    ${card(`
      <div class="p-5">
        ${sectionTitle(`Kaybedilen Adaylar`, `<span class="text-[11px] rounded-full bg-coral-soft text-coral font-bold px-2 py-0.5">${kayip.length}</span>`)}
        <div class="grid gap-2 sm:grid-cols-2">
          ${kayip.map(a => `
            <button data-appdetail="${a.id}" class="min-w-0 flex items-center gap-3 rounded-xl border border-line px-3 py-2.5 text-left hover:bg-paper/60">
              <span class="min-w-0 flex-1">
                <span class="block text-sm font-semibold truncate">${esc(a.child)}</span>
                <span class="block text-[11px] text-coral truncate">${esc(a.lostReason ?? "Sebep belirtilmedi")}</span>
              </span>
              <span class="text-[10px] text-inksoft shrink-0">${fmtDate(a.stageSince)}</span>
            </button>`).join("")}
        </div>
      </div>`)}
  </div>` : ""}`;
}

export function basvuruKarti(a, asamaIndex) {
  const k = kontenjan(a.targetClassId);
  const bekleme = gunFarki(a.stageSince);
  const gecikmis = bekleme > BEKLEME_ESIGI[a.stage];
  const r = a.appointmentAt ? randevuMetni(a.appointmentAt) : null;
  const kardes = a.siblingId ? stu(a.siblingId) : null;

  return card(`
    <div class="p-3">
      <button data-appdetail="${a.id}" class="w-full text-left">
        <div class="flex items-start justify-between gap-2">
          <span class="min-w-0">
            <span class="block font-semibold text-sm truncate">${esc(a.child)}</span>
            <span class="block text-[11px] text-inksoft">${age(a.birthDate)}</span>
          </span>
          <span class="text-[10px] font-bold rounded-full px-1.5 py-0.5 shrink-0
            ${gecikmis ? "bg-coral-soft text-coral" : "bg-paper text-inksoft"}">${bekleme}g</span>
        </div>

        <div class="flex flex-wrap gap-1 mt-2">
          ${k ? `<span class="text-[10px] font-semibold rounded-full px-2 py-0.5" style="background:${k.c.color}1A;color:${k.c.color}">${esc(k.c.name)}</span>` : ""}
          ${k && k.bos <= 0
            ? `<span class="text-[10px] font-bold rounded-full bg-coral-soft text-coral px-2 py-0.5">Kontenjan dolu</span>`
            : k && k.bos <= 2 ? `<span class="text-[10px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2 py-0.5">${k.bos} yer kaldı</span>` : ""}
          ${kardes ? `<span class="text-[10px] font-semibold rounded-full bg-teal-soft text-teal px-2 py-0.5">Kardeş</span>` : ""}
        </div>

        ${r ? `<div class="text-[11px] mt-2 font-semibold ${r.gecmis ? "text-coral" : "text-grape"}">📅 ${r.gun} ${r.saat}${r.gecmis ? " · geçti" : ""}</div>` : ""}
        <div class="text-[11px] text-inksoft mt-1.5 truncate">${esc(a.parent)} · ${esc(a.phone)}</div>
        <div class="text-[10px] text-inksoft/70 mt-0.5">${esc(a.source)}</div>
      </button>

      <div class="flex items-center gap-1 mt-2 pt-2 border-t border-line/70">
        ${asamaIndex > 0
          ? `<button data-appmove="${a.id}:-1" title="Önceki aşama" class="w-7 h-7 rounded-lg border border-line hover:bg-paper grid place-items-center text-inksoft">←</button>`
          : `<span class="w-7"></span>`}
        ${asamaIndex < HUNI.length - 1
          ? `<button data-appmove="${a.id}:1" title="Sonraki aşama" class="flex-1 h-7 rounded-lg text-white text-[11px] font-semibold" style="background:${HUNI[asamaIndex + 1].color}">${HUNI[asamaIndex + 1].label} →</button>`
          : `<span class="flex-1 text-center text-[11px] font-semibold text-teal">Kayıt tamamlandı</span>`}
        <button data-applost="${a.id}" title="Kaybedildi olarak işaretle" class="w-7 h-7 rounded-lg border border-line hover:bg-coral-soft hover:border-coral/40 grid place-items-center text-inksoft">✕</button>
      </div>
    </div>`, "min-w-0");
}

// ---------- Başvuru detay & yeni kayıt formu ----------
export function openApplicationModal(id) {
  const a = basvuruOf(id);
  if (!a) return;
  const k = kontenjan(a.targetClassId);
  const kardes = a.siblingId ? stu(a.siblingId) : null;
  const asama = [...HUNI, KAYIP].find(h => h.id === a.stage);
  const idx = HUNI.findIndex(h => h.id === a.stage);
  const r = a.appointmentAt ? randevuMetni(a.appointmentAt) : null;

  document.getElementById("modalBox").innerHTML = `
    <div class="h-2.5 rounded-t-2xl" style="background:${asama.color}"></div>
    <div class="p-6">
      <div class="flex items-start gap-4">
        <div class="flex-1 min-w-0">
          <h2 class="font-display font-bold text-xl">${esc(a.child)}</h2>
          <div class="flex items-center gap-2 mt-1 flex-wrap">
            <span class="text-[11px] font-bold rounded-full px-2.5 py-0.5" style="background:${asama.color}1A;color:${asama.color}">${asama.label}</span>
            <span class="text-xs text-inksoft">${age(a.birthDate)} · ${fmtDate(a.birthDate)} doğumlu</span>
          </div>
        </div>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="grid grid-cols-2 gap-3 mt-5 text-sm">
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Veli</div>
          <div class="font-semibold mt-0.5 truncate">${esc(a.parent)}</div>
          <div class="text-[11px] text-inksoft">${esc(a.phone)}</div>
        </div>
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Kaynak</div>
          <div class="font-semibold mt-0.5">${esc(a.source)}</div>
          <div class="text-[11px] text-inksoft">${fmtDate(a.createdAt)} başvurdu</div>
        </div>

        <div class="rounded-xl p-3 col-span-2" style="background:${k ? k.c.color + "14" : "#F7F6FB"}">
          <div class="text-[11px] font-bold uppercase" style="color:${k ? k.c.color : "#5A5470"}">Hedef Sınıf</div>
          ${k ? `
            <div class="flex items-center justify-between mt-0.5">
              <span class="font-semibold">${esc(k.c.name)} · ${k.c.age}</span>
              <span class="text-sm font-bold" style="color:${k.c.color}">${k.dolu}/${k.kapasite}</span>
            </div>
            <div class="text-[11px] mt-0.5 ${k.bos <= 0 ? "text-coral font-semibold" : "text-inksoft"}">
              ${k.bos <= 0 ? "Kontenjan dolu — bekleme listesine alınmalı" : `${k.bos} yer boş · ${money(k.c.tuition)} / ay`}
            </div>` : `<div class="text-inksoft mt-0.5">Sınıf atanmadı</div>`}
        </div>

        ${r ? `
        <div class="rounded-xl p-3 col-span-2 ${r.gecmis ? "bg-coral-soft" : "bg-grape-soft"}">
          <div class="text-[11px] font-bold uppercase ${r.gecmis ? "text-coral" : "text-grape"}">Randevu</div>
          <div class="font-semibold mt-0.5">${r.gun} · ${r.saat}${r.gecmis ? " — tarih geçti, sonuç girilmedi" : ""}</div>
        </div>` : ""}

        ${kardes ? `
        <div class="rounded-xl bg-teal-soft p-3 col-span-2">
          <div class="text-[11px] font-bold text-teal uppercase">Kurumdaki Kardeşi</div>
          <div class="font-semibold mt-0.5">${esc(kardes.name)} · ${esc(cls(kardes.classId).name)}</div>
          <div class="text-[11px] text-inksoft">Kayıtta %10 kardeş indirimi uygulanır.</div>
        </div>` : ""}

        ${a.lostReason ? `
        <div class="rounded-xl bg-coral-soft p-3 col-span-2">
          <div class="text-[11px] font-bold text-coral uppercase">Kaybedilme Sebebi</div>
          <div class="mt-0.5">${esc(a.lostReason)}</div>
        </div>` : ""}

        ${a.note ? `
        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="text-[11px] font-bold text-inksoft uppercase">Not</div>
          <div class="text-xs mt-1">${esc(a.note)}</div>
        </div>` : ""}

        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="text-[11px] font-bold text-inksoft uppercase">Aşama</div>
          <div class="text-[11px] text-inksoft mt-0.5">${gunFarki(a.stageSince)} gündür ${asama.label.toLocaleLowerCase("tr-TR")} aşamasında</div>
          <div class="flex gap-2 mt-2">
            ${idx > 0 ? `<button data-appmove="${a.id}:-1" class="rounded-xl border border-line bg-white text-sm font-semibold px-3 py-2">← Geri al</button>` : ""}
            ${idx >= 0 && idx < HUNI.length - 1
              ? `<button data-appmove="${a.id}:1" class="flex-1 rounded-xl text-white text-sm font-semibold px-3 py-2" style="background:${HUNI[idx + 1].color}">${HUNI[idx + 1].label} aşamasına taşı</button>`
              : ""}
            ${a.stage === "kaybedildi"
              ? `<button data-appmove="${a.id}:geri" class="flex-1 rounded-xl border border-line bg-white text-sm font-semibold px-3 py-2">Huniye geri al</button>`
              : `<button data-applost="${a.id}" class="rounded-xl border border-coral/40 text-coral text-sm font-semibold px-3 py-2">Kaybedildi</button>`}
          </div>
        </div>
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;
  bindApplicationEvents(document.getElementById("modalBox"));
}

export function openNewApplicationForm() {
  const t = B();
  document.getElementById("modalBox").innerHTML = `
    <div class="h-2.5 rounded-t-2xl bg-sky"></div>
    <div class="p-6">
      <div class="flex items-start justify-between gap-4">
        <h2 class="font-display font-bold text-xl">Yeni Başvuru</h2>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <p class="text-[11px] text-inksoft mt-1">${esc(t.name)} · yeni aday hunisi başında açılır.</p>

      <div class="grid gap-3 sm:grid-cols-2 mt-4 text-sm">
        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Çocuğun adı soyadı</span>
          <input id="fChild" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Örn. Deniz Yılmaz">
        </label>
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Doğum tarihi</span>
          <input id="fBirth" type="date" max="${BUGUN}" class="w-full mt-1 rounded-xl border border-line px-3 py-2">
        </label>
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Hedef sınıf</span>
          <select id="fClass" class="w-full mt-1 rounded-xl border border-line px-3 py-2 bg-white">
            ${t.classes.map(c => `<option value="${c.id}">${esc(c.name)} · ${c.age}</option>`).join("")}
          </select>
        </label>
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Veli adı</span>
          <input id="fParent" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Örn. Selin Yılmaz">
        </label>
        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Telefon</span>
          <input id="fPhone" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="0533 000 00 00">
        </label>
        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Kaynak</span>
          <select id="fSource" class="w-full mt-1 rounded-xl border border-line px-3 py-2 bg-white">
            ${KAYNAKLAR.map(k => `<option>${esc(k)}</option>`).join("")}
          </select>
        </label>
        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Not</span>
          <textarea id="fNote" rows="2" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Görüşmede konuşulanlar…"></textarea>
        </label>
      </div>

      <div id="fError" class="hidden rounded-xl bg-coral-soft text-coral text-sm font-semibold px-3 py-2 mt-3"></div>

      <div class="flex gap-2 mt-4">
        <button id="fSave" class="flex-1 rounded-xl bg-teal text-white text-sm font-semibold px-4 py-2.5">Başvuruyu kaydet</button>
        <button id="fCancel" class="rounded-xl border border-line text-sm font-semibold px-4 py-2.5">Vazgeç</button>
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;
  document.getElementById("fCancel").onclick = closeModal;

  document.getElementById("fSave").onclick = () => {
    const al = id => document.getElementById(id).value.trim();
    const hata = document.getElementById("fError");
    const eksik = [];
    if (!al("fChild")) eksik.push("çocuğun adı");
    if (!al("fBirth")) eksik.push("doğum tarihi");
    if (!al("fParent")) eksik.push("veli adı");
    if (!al("fPhone")) eksik.push("telefon");
    if (eksik.length) {
      hata.textContent = `Şu alanlar gerekli: ${eksik.join(", ")}.`;
      hata.classList.remove("hidden");
      return;
    }
    Basvurular.ekle(state.branchId, {
      id: `yeni-${Date.now()}`,
      child: al("fChild"),
      birthDate: al("fBirth"),
      gender: "—",
      parent: al("fParent"),
      phone: al("fPhone"),
      source: document.getElementById("fSource").value,
      targetClassId: document.getElementById("fClass").value,
      stage: "basvuru",
      createdAt: BUGUN,
      stageSince: BUGUN,
      appointmentAt: null,
      siblingId: null,
      note: al("fNote"),
    });
    closeModal();
    rerender();
  };
}

export function bindApplicationEvents(root) {
  root.querySelectorAll("[data-appdetail]").forEach(el =>
    el.addEventListener("click", e => { e.stopPropagation(); openApplicationModal(el.dataset.appdetail); }));

  root.querySelectorAll("[data-appmove]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const [id, yon] = el.dataset.appmove.split(":");
      const a = basvuruOf(id);
      if (!a) return;
      let alan;
      if (yon === "geri") {
        alan = { stage: "basvuru", lostReason: null };
      } else {
        const i = HUNI.findIndex(h => h.id === a.stage);
        const hedef = HUNI[i + Number(yon)];
        if (!hedef) return;
        alan = { stage: hedef.id };
        if (hedef.id === "kayit" || hedef.id === "basvuru") alan.appointmentAt = null;
      }
      alan.stageSince = BUGUN;
      Basvurular.guncelle(state.branchId, a, alan,
        `${a.child} başvurusu ${alan.stage} aşamasına alındı`);
      rerender();
      if (!document.getElementById("modal").classList.contains("hidden")) openApplicationModal(id);
    }));

  root.querySelectorAll("[data-applost]").forEach(el =>
    el.addEventListener("click", e => {
      e.stopPropagation();
      const a = basvuruOf(el.dataset.applost);
      if (!a) return;
      Basvurular.guncelle(state.branchId, a, {
        stage: "kaybedildi",
        stageSince: BUGUN,
        appointmentAt: null,
        lostReason: a.lostReason ?? "Aday takipten çıkarıldı",
      }, `${a.child} başvurusu kaybedildi olarak işaretlendi`);
      closeModal();
      rerender();
    }));

  root.querySelectorAll("[data-newapp]").forEach(el =>
    el.addEventListener("click", () => openNewApplicationForm()));

  root.querySelectorAll("[data-newstaff]").forEach(el =>
    el.addEventListener("click", () => openNewStaffForm()));
}



// ---------- Gelecek dönem projeksiyonu (§10) ----------
function projeksiyonKarti() {
  const p = donemProjeksiyonu(state.branchId);
  const acilacak = p.siniflar.filter(x => x.projeksiyonBos > 0);

  return card(`
    <div class="p-5">
      ${sectionTitle(
        `${p.donem.slice(0, 4)} Eylül Kontenjan Projeksiyonu`,
        `<span class="text-[11px] text-inksoft hidden sm:block">Yaş grubu geçişleri hesaba katılmıştır</span>`,
      )}
      <p class="text-[11px] text-inksoft mb-3">
        Bugün dolu görünen sınıf, büyükler ilkokula geçince açılabilir.
        Bekleyen aileye "Eylül'de yeriniz var" diyebilmek için bu hesap gerekiyor.
        İlkokul eşiği ${ILKOKUL_ESIGI_AY} ay (eylül sonunda dolduranlar).
      </p>

      <div class="overflow-x-auto">
        <table class="w-full text-sm min-w-[560px]">
          <thead><tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line">
            <th class="py-2 pr-3">Sınıf</th>
            <th class="py-2 pr-3 text-center">Bugün</th>
            <th class="py-2 pr-3 text-center">Çıkan</th>
            <th class="py-2 pr-3 text-center">Gelen</th>
            <th class="py-2 pr-3 text-center">Eylül</th>
            <th class="py-2">Boş</th>
          </tr></thead>
          <tbody class="divide-y divide-line/70">
            ${p.siniflar.map(x => `
              <tr>
                <td class="py-2.5 pr-3">${classChip(x.sinif.id)}</td>
                <td class="py-2.5 pr-3 text-center">${x.bugunDolu}/${x.kapasite}</td>
                <td class="py-2.5 pr-3 text-center ${x.gidecek ? "text-coral font-semibold" : "text-inksoft"}">
                  ${x.gidecek ? `−${x.gidecek}` : "—"}
                  ${x.mezun ? `<span class="block text-[10px] text-inksoft">${x.mezun} ilkokula</span>` : ""}
                </td>
                <td class="py-2.5 pr-3 text-center ${x.gelecek ? "text-teal font-semibold" : "text-inksoft"}">
                  ${x.gelecek ? `+${x.gelecek}` : "—"}
                </td>
                <td class="py-2.5 pr-3 text-center font-semibold">${x.projeksiyonDolu}/${x.kapasite}</td>
                <td class="py-2.5">
                  ${x.projeksiyonBos > 0
                    ? `<span class="text-[11px] font-bold rounded-full bg-teal-soft text-teal px-2 py-0.5">${x.projeksiyonBos} yer</span>`
                    : `<span class="text-[11px] font-bold rounded-full bg-coral-soft text-coral px-2 py-0.5">dolu</span>`}
                </td>
              </tr>`).join("")}
          </tbody>
        </table>
      </div>

      ${acilacak.length ? `
        <div class="rounded-xl bg-teal-soft p-3 mt-3 text-xs">
          <span class="font-bold text-teal">Eylül'de açılacak yerler:</span>
          ${acilacak.map(x => `${esc(x.sinif.name)} (${x.projeksiyonBos})`).join(" · ")}
        </div>` : ""}
    </div>`, "mb-4");
}

// ---------- Bekleme listesi (§10) ----------
function beklemeKarti() {
  const listeler = tumBeklemeListeleri(state.branchId);
  if (!listeler.length) return "";

  return card(`
    <div class="p-5">
      ${sectionTitle("Bekleme Listesi", `<span class="text-[11px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2.5 py-1">${listeler.reduce((a, x) => a + x.liste.length, 0)} aday</span>`)}
      <p class="text-[11px] text-inksoft mb-3">
        Kontenjanı dolmuş sınıflar. Sıralama kardeş önceliği, ardından başvuru tarihine göre.
      </p>

      ${listeler.map(({ sinif, liste }) => `
        <div class="mb-3">
          <div class="flex items-center gap-2 mb-1.5">
            ${classChip(sinif.id)}
            <span class="text-[11px] text-inksoft">${liste.length} bekleyen</span>
          </div>
          <ol class="space-y-1.5">
            ${liste.map(x => `
              <li data-appdetail="${x.basvuru.id}" class="flex items-center gap-3 rounded-xl border ${x.kardes ? "border-teal/50 bg-teal-soft/20" : "border-line"} px-3 py-2 cursor-pointer hover:bg-paper/60">
                <span class="w-6 h-6 rounded-full bg-ink text-white text-[11px] font-bold grid place-items-center shrink-0">${x.sira}</span>
                <span class="min-w-0 flex-1">
                  <span class="block text-sm font-semibold truncate">${esc(x.basvuru.child)}</span>
                  <span class="block text-[11px] text-inksoft truncate">
                    ${esc(x.basvuru.parent)} · ${x.bekleyenGun} gündür bekliyor
                  </span>
                </span>
                ${x.kardes ? `<span class="text-[10px] font-bold rounded-full bg-teal text-white px-2 py-0.5 shrink-0">Kardeş önceliği</span>` : ""}
              </li>`).join("")}
          </ol>
        </div>`).join("")}
    </div>`, "mb-4");
}
